import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation InviteCodeActivate($code: String!){
        invite_code_activation(code: $code) {
            success,
        }
    }
`;

export async function inviteCodeActivate(code: string)
: Promise<{ success: boolean }> {
    const result: FetchResult<{ invite_code_activation: { success: boolean } }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: {
            code,
        },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.invite_code_activation;
}
